import { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import ConversationList from "../components/ConversationList.jsx";
import ChatPanel from "../components/ChatPanel";
import "../styles/messages.css";

function MessagesPage() {
  const [activeConversation, setActiveConversation] = useState(null);
  const [conversationUpdate, setConversationUpdate] = useState(null);

  useEffect(() => {
    document.title = "Messages • CodeGram";
  }, []);

  return (
    <div className="profile-page">
      <Sidebar />

      <main className="messages-content">
        <div className="messages-container">
          <ConversationList
            onSelectConversation={setActiveConversation}
            activeConversation={activeConversation}
            conversationUpdate={conversationUpdate}
          />

          <ChatPanel
            conversation={activeConversation}
            onMessageChange={(convId, message) =>
              setConversationUpdate({ convId, message })
            }
          />
        </div>
      </main>
    </div>
  );
}

export default MessagesPage;